import { Fragment, useRef, useState, useEffect } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import {MailIcon} from "@heroicons/react/solid"
import app from "../../api/firebaseConf"
import { collection, getFirestore, addDoc, doc, getDocs, deleteDoc, getDoc, setDoc } from "firebase/firestore";

export default function BtnModalConfig(props){
    const cssinput = "appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white";
    const csslabel = "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2";

    const initState = {correo: '', id:  '', msg: ''}

    const cancelButtonRef = useRef(null)
    const [values, setValues] = useState([])
    const [mails, setMails] = useState([])
    const [refresh, setRefresh] = useState([])
    const [mensaje, setMensaje] = useState(initState)
    

    const db = getFirestore(app)

    const handleInputChange = e => {
      const {name, value} = e.target
      setValues({...values, [name]: value})
    }

    const handleInputChange2 = e => {
    const {name, value} = e.target
    setMensaje({id:mensaje.id, msg: value})
    }

    const handleSubmit = (e) => {
      e.preventDefault();
      if (mensaje.msg !== '')
        setItem(mensaje)
      if (values.length !== 0){
        addItems(values)     
      }
        
    }


    const addItems = async(object) =>{
      await addDoc(collection(db,'emails'), object)
      setRefresh(!refresh)
    }

    const onDelete = async(id ) => {
            await deleteDoc(doc(db, 'emails',id))
            setRefresh(!refresh)
    }

    const setItem  = async(item) => {
       await setDoc(doc(db,'message','emergencia'), {mensaje: item.msg});
    }
    

    useEffect(()=>{
      const emails = []
      const obtenerDatosEmail =  async()=>{
        const datos = await getDocs(collection(db,'emails'));
        datos.forEach((doc)=>{
          emails.push({correo:doc.data().correo, id:doc.id})
        })

        setMails(emails)
      }
      const obtenerDatosMensaje =  async()=>{
        const datos = await getDoc(doc(db,'message','emergencia'));
        setMensaje({msg: datos.data().mensaje, id:datos.id})      
      }

      obtenerDatosEmail()
      obtenerDatosMensaje()

    },[refresh, props.id])

    return <Transition.Root show={props.open} as={Fragment}>
    <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={props.close}>
      {
        <Transition.Child
        as={Fragment}
        enter="ease-out duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="ease-in duration-200"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </Transition.Child>}
      
      <div className="fixed z-10 inset-0 overflow-y-auto">
        <div className="flex items-center sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <Dialog.Panel className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <div className="grid justify-items-end">
                <button 
                  type="button" 
                  className="inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 " 
                  onClick={props.close} 
                  ref={cancelButtonRef}> X </button>
                </div>

                {/*Formulario para dispositivos*/}
                  <form className="w-full max-w-lg" onSubmit={handleSubmit}>
                      <div className="grid grid-cols-1  gap-x-2 mt-2">
                          <div>
                          <label className={csslabel}>Correo electronico de emergencia</label>
                          <input
                              className={cssinput}
                              type="email"
                              name = "correo"
                              placeholder="example@gmail.com"
                              onChange={handleInputChange}
                          />
                          </div>

                          <div>
                          {/* <label className={csslabel}>Mensaje</label> */}
                          <textarea id={mensaje.id} rows="4" 
                          name = "mensaje" 
                          placeholder="Mensaje de Emergencia..."
                          onChange={handleInputChange2}
                          value={mensaje.msg}
                          className="block appearance-none mb-3 p-2.5 w-full text-gray-700 bg-gray-200 rounded-lg border border-gray-300 focus:outline-none focus:bg-white"></textarea>
                          </div>
                          <hr  className='pb-3'/>
                          {
                            mails.map((dato)=>(
                            <div  key={dato.id} className="flex p-3 mb-4 bg-slate-100 rounded-lg dark:bg-slate-200" role="alert">
                            <MailIcon className='w-5 h-5 fill-slate-700'/>
                            <span className="sr-only">Info</span>
                            <div className="ml-3 text-sm font-medium text-slate-700 dark:text-slate-800">
                                 {dato.correo}
                            </div>
                            <button onClick={()=>onDelete(dato.id)} type="button" className="ml-auto -mx-1.5 -my-1.5 bg-slate-100 text-slate-500 rounded-lg focus:ring-2 focus:ring-slate-400 p-1.5 hover:bg-slate-200 inline-flex h-8 w-8 dark:bg-slate-200 dark:text-slate-600 dark:hover:bg-slate-300" data-dismiss-target="#alert-4" aria-label="Close">
                                <span className="sr-only">Close</span>
                                <svg aria-hidden="true" className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                            </button>
                            </div>)) 
                          }
                      </div>
                  
                      <div className=" px-4 py-3 sm:px-1 sm:flex sm:flex-row-reverse">
                          <button className="w-full inline-flex justify-center rounded-md border border-transparent 
                          shadow-sm px-4 py-2 bg-red-600 text-base font-medium 
                          text-white hover:bg-red-700 focus:outline-none focus:ring-2 
                          focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm" onClick={props.close}>
                          Agregar
                          </button>
                      </div>
                  </form>
              </div>         
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </div>
    </Dialog>
  </Transition.Root>

}